import { Component } from '@angular/core';
import { ABOUT_BEACHWATCH_PROTOCOL_URL_EXTERNAL, ACCESSIBILITY_URL_EXTERNAL, BEACHWATCH_FACEBOOK_URL_EXTERNAL, BEACHWATCH_TWITTER_URL_EXTERNAL, COPYRIGHT_DISCLAIMER_PAGE_URL_EXTERNAL, NHMRC_PAGE_URL_EXTERNAL, PRIVACY_AND_SECURITY_URL_EXTERNAL, STATE_OF_BEACHES_REPORT_URL_EXTERNAL } from '../models/external-urls';
import { AppMonitoringService } from 'src/app/services/logging.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {

	public STATE_OF_BEACHES_REPORT_URL = STATE_OF_BEACHES_REPORT_URL_EXTERNAL;

	public BEACHWATCH_TWITTER_URL = BEACHWATCH_TWITTER_URL_EXTERNAL;

	public BEACHWATCH_FACEBOOK_URL = BEACHWATCH_FACEBOOK_URL_EXTERNAL;

	public NHMRC_PAGE_URL = NHMRC_PAGE_URL_EXTERNAL;

	public ABOUT_BEACHWATCH_PROTOCOL_URL = ABOUT_BEACHWATCH_PROTOCOL_URL_EXTERNAL;

	public ACCESSIBILITY_URL = ACCESSIBILITY_URL_EXTERNAL;

	public COPYRIGHT_DISCLAIMER_PAGE_URL = COPYRIGHT_DISCLAIMER_PAGE_URL_EXTERNAL;

	public PRIVACY_AND_SECURITY_URL = PRIVACY_AND_SECURITY_URL_EXTERNAL;

	constructor(private appMonitoring: AppMonitoringService) {}

	navigateToStateOfBeaches(): void {
		// track the site that was clicked from the GlobalSearch
		this.appMonitoring.logEvent('StateOfTheBeachesReportClick',{})
    }


}
